module.exports = __webpack_public_path__ + "img/compliance2.25089c5b.svg";